import { render, staticRenderFns } from "./grade.vue?vue&type=template&id=28fbe6b4&scoped=true"
import script from "./grade.vue?vue&type=script&lang=js"
export * from "./grade.vue?vue&type=script&lang=js"
import style0 from "./grade.vue?vue&type=style&index=0&id=28fbe6b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fbe6b4",
  null
  
)

export default component.exports